$splitter-gutter-background-color: #e8e8e8;

/* Flex layout */

.af-split {
  display: flex;
  height: 100%;
  overflow: hidden;

  &--horizontal {
    flex-direction: row;
  }

  &--vertical {
    flex-direction: column;
  }
}

/* Gutter style */

.af-split {
  &__gutter {
    background-color: $splitter-gutter-background-color;
    background-repeat: no-repeat;
    background-position: 50%;
  }

  &--horizontal > &__gutter {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');
    cursor: ew-resize;
    border-top: none;
    border-bottom: none;
  }

  &--vertical > &__gutter {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');
    cursor: ns-resize;
    border-left: none;
    border-right: none;
  }
}
